import React from "react";
import { VStack, HStack, Text, Box, Separator } from "@chakra-ui/react";
import SectionHeader from "../../../CustomUi/SectionHeader";
import useThemeColors from "../../../../hooks/useThemeColors";
import Cad from "../../../CustomUi/Cad";
import CustomButton from "../../../CustomUi/CustomButton";
import TextInput from "../../../CustomUi/TextInput";
import SelectInput from "../../../CustomUi/SelectInput";
import CustomNumberInput from "../../../CustomUi/CustomNumberInput";

interface TermConfigSectionProps {
  title: string;
  subtitle: string;
  description: string;
  inputType: "select" | "number" | "date";
  value: string | number | undefined;
  onChange: (e: any) => void;
  onSave: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  buttonText: string;
  placeholder?: string;
  options?: Array<{ id: string; name: string }>;
  accentColor: string;
}

const TermConfigSection: React.FC<TermConfigSectionProps> = ({
  title,
  subtitle,
  description,
  inputType,
  value,
  onChange,
  onSave,
  isLoading,
  isDisabled,
  buttonText,
  placeholder,
  options,
  accentColor,
}) => {
  const colors = useThemeColors();

  const renderInput = () => {
    switch (inputType) {
      case "select":
        return (
          <SelectInput
            name="config"
            value={value as string}
            onChange={(e) => onChange(e)}
            collection={
              options?.map((opt) => ({ label: opt.name, value: opt.id })) || []
            }
            placeholder={placeholder || ""}
          />
        );
      case "number":
        return (
          <CustomNumberInput
            value={value?.toString() || ""}
            onChange={(val) => onChange({ target: { value: val } })}
            placeholder={placeholder}
            w={"full"}
          />
        );
      case "date":
        return (
          <TextInput
            name="config"
            type="date"
            value={value as string}
            onChange={onChange}
            placeholder={placeholder}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Cad>
      <VStack gap={6} align="stretch">
        <SectionHeader title={title} subtitle={subtitle} />

        <Separator />

        <VStack gap={4} align="stretch">
          <Box>
            <Text fontSize="sm" color={colors.text.secondary} mb={4}>
              {description}
            </Text>
          </Box>

          <HStack
            gap={4}
            flexDir={{ base: "column", md: "row" }}
            alignItems={["stretch", "center"]}
          >
            <VStack gap={2} align="start" flex={1}>
              {renderInput()}
            </VStack>
            <CustomButton
              colorPalette={accentColor}
              label={buttonText}
              onClick={onSave}
              loading={isLoading}
              disabled={isDisabled}
              variant="outline"
            />
          </HStack>
        </VStack>
      </VStack>
    </Cad>
  );
};

export default TermConfigSection;
